import { AppRoutes } from '../../../Core/App/AppRoutes';
import { AppRouteType } from '../../Components/Templates/AppRouter/AppRouteType';
import { PrivateRoute } from '../../Components/Templates/AppRouter/PrivateRoute';
import { LoadableListVehiculePage } from '../../Pages/Vehicules/ListVehicule/LoadableListVehiculePage';
import { LoadableVehiculeCreatePage } from '../../Pages/Vehicules/VehiculeCreate/LoadableVehiculeCreatePage';
import { LoadableVehiculeDetailsPage } from '../../Pages/Vehicules/VehiculeDetails/LoadableVehiculeDetailsPage';

const getListVehiculeRoute = (props: object): AppRouteType => ({
    id: AppRoutes.VEHICULE_LIST,
    render: PrivateRoute,
    props: {
        exact: true,
        path: AppRoutes.VEHICULE_LIST,
        component: LoadableListVehiculePage,
        ...props,
    },
});

const getCreateVehiculeRoute = (props: object): AppRouteType => ({
    id: AppRoutes.VEHICULE_CREATE,
    render: PrivateRoute,
    props: {
        exact: true,
        path: AppRoutes.VEHICULE_CREATE,
        component: LoadableVehiculeCreatePage,
        ...props,
    },
});

const getDetailsVehiculeRoute = (props: object): AppRouteType => ({
    id: AppRoutes.VEHICULE_DETAILS,
    render: PrivateRoute,
    props: {
        exact: true,
        path: AppRoutes.VEHICULE_DETAILS,
        component: LoadableVehiculeDetailsPage,
        ...props,
    },
});

export const getVehiculeRoutes = (args: object) => [
    getListVehiculeRoute(args),
    getCreateVehiculeRoute(args),
    getDetailsVehiculeRoute(args),
];
